import React from "react";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";

import SliderImgOne from "../images/slider-img-one.jpg";
import SliderImgTwo from "../images/slider-img-two.jpg";
import SliderImgThree from "../images/slider-img-three.jpg";
import SliderImgFour from "../images/slider-img-four.jpg";

const content = [
  {
    title: "Prestigious TAF Estates Now Available!",
    description:
      "We are selling serviced plots at the new TAF Murraya Gardens in Brufut, Dalaba Estate in Sukuta, and Tulip Gardens in Jambanjelly.",
    image: SliderImgOne,
  },
  {
    title: "TAF Murraya Gardens",
    description:
      "TAF Africa Global Proudly presents MURRAYA GARDENS ESTATE located in Brufut.",
    button: <button>Read More</button>,
    image: SliderImgTwo,
  },
  {
    title: "Tulip Gardens",
    description: "All New TAF Tulip Gardens Estate, located in Jambanjelly.",
    button: <button>Read More</button>,
    image: SliderImgThree,
  },
  {
    title: "Don't wait to buy a home...buy a home and wait",
    description: "We Don't Sell Houses, We sell quality and luxurious homes…",
    button: <button>Read More</button>,
    image: SliderImgFour,
  },
];

const Carousel = () => {
  return (
    <section>
      <div className="rev_slider_wrapper" id="home">
        <div className="rev_slider" id="slider-1">
          <Slider autoplay={1000} className="slider-wrapper">
            {content.map((item, index) => (
              <div
                key={index}
                className="slider-content"
                style={{
                  background: `url('${item.image}') no-repeat center center`,
                }}
              >
                <div className="inner">
                  <h1>{item.title}</h1>
                  <p>{item.description}</p>
                  {item.button}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};
export default Carousel;
